<div class="container" id="search-conatiner">
  <div class="parent" [ngClass]="getBorderClass()" id="search-parent-wrapper">
    <div class="select-container" id="select-container-content" *ngIf="displaySelect()">
      <app-select
        [data]="searchOptions"
        [height]="'2.8em'"
        [isDisabled]="isSearchBoxDisabled"
        [width]="dropDownWidth"
        [defaultValue]="defaultSelectValue || searchOptions[0]"
        (selectionChangeHandler)="onSelectionChange($event)"
        singleSelectPanelClass="single-select-search-box"
      ></app-select>
    </div>
    <div class="vertical-line" id="search-vertical-liner" *ngIf="displaySelect()">
      <div class="vertical"></div>
    </div>
    <div class="input-container" id="search-input-conatiner">
      <app-input
        #appInput
        class="input"
        [isRequired]="false"
        [placeholder]="getPlaceholderText() | translate"
        (closeIconClick)="onCancel()"
        prefixIcon="search"
        [isDisabled]="isSearchBoxDisabled"
        (changeInput)="onInputChangeHandler($event)"
        (enterPress)="onInputEnter($event)"
        (inputOnFocus)="onFocus()"
        (inputOnBlur)="onBlur()"
        (paste)="onPaste($event)"
        (keyUp)="onKeyUp($event)"
        [hasCustomError]="hasCustomError"
        [disableClose]="disableClose"
      ></app-input>
    </div>
  </div>

  <div class="search-button" *ngIf="!hideButton" id="search-button-wrapper">
    <app-spinner
      id="shared-search-button-spinner"
      *ngIf="showSpinner; else showSearchBtn"
      [diameter]="'medium'"
    ></app-spinner>
    <ng-template #showSearchBtn>
      <app-button
        height="3.6em"
        [text]="'common.placeholder.search' | translate"
        (buttonClick)="onClick()"
        class="search-buutton-demo"
        [isDisabled]="disableButton"
      ></app-button>
    </ng-template>
  </div>
</div>
<app-text
  id="shared-search-error-message"
  [textStyleType]="'body2'"
  class="error-text"
  *ngIf="hasCustomError"
  >{{ customErrorMsg | translate }}</app-text
>
